import {posService} from "@/common/api.service"

const initialStates = {
    status: 'loading',
    psp: 'PASARGAD',
    can_change: false,
    settings_status: 'loading',
    form_data: {
        customer_detail: {
            is_foreign_nationals: false,
            signature_holder: {},
        },
        bank_account_detail: {
            multi_account_details: [],
            multi_account_owners: [],
        },
        stakeholders: [],
        sub_customers: [],
        device_info: {},
        address_info: {shaparak_address:''},
        images_url: {
            national_card_img: '',
            birth_certificate_card_img: '',
            national_card_behind_img: '',
            last_newspaper_img: '',
            statute_pages_img: '',
            foundation_img: '',
            passport_img: '',
            amayesh_card_img: '',
            work_permit_img: '',
            business_license_img: '',
            first_ownership_document_img: '',
            second_ownership_document_img: '',
            communicating_documents_img: '',
            license_granting_certificate_img: '',
            trust_number_img: '',
            iban_certificate: '',
            change_iban_form: '',
            installation_form: '',
            deposit_receipt: '',
            phone_bill: '',
            e_trust_certificate: '',
            card_acceptance_contract: '',
            national_card_of_second_sh: '',
            renting_or_ownership_document: '',
            delegation_of_authority_form: '',
            last_newspaper_img_introduce_sh: '',
            delegation_of_authority_national_card: '',
            birth_certificate_first_page_of_first_sh: '',
            birth_certificate_first_page_of_second_sh: '',
            certificate_form: '',
        },
        documents: {
            national_card_img: '',
            birth_certificate_card_img: '',
            national_card_behind_img: '',
            last_newspaper_img: '',
            statute_pages_img: '',
            foundation_img: '',
            passport_img: '',
            amayesh_card_img: '',
            work_permit_img: '',
            business_license_img: '',
            first_ownership_document_img: '',
            second_ownership_document_img: '',
            communicating_documents_img: '',
            license_granting_certificate_img: '',
            trust_number_img: '',
            iban_certificate: '',
            change_iban_form: '',
            installation_form: '',
            deposit_receipt: '',
            phone_bill: '',
            e_trust_certificate: '',
            card_acceptance_contract: '',
            national_card_of_second_sh: '',
            national_card_of_first_sh: '',
            renting_or_ownership_document: '',
            delegation_of_authority_form: '',
            last_newspaper_img_introduce_sh: '',
            delegation_of_authority_national_card: '',
            birth_certificate_first_page_of_first_sh: '',
            birth_certificate_first_page_of_second_sh: '',
            certificate_form: '',
        },
    },
    constants: null,
    request_details: null,
    datatable_status: null,
    stakeholder_detail: null,
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    setPsp(state, psp) {
        state.status = 'setPsp'
        state.psp = psp
    },
    clearConstants(state) {
        state.status = 'clearConstants'
        state.constants = null
    },
    successConstants(state, constants) {
        state.status = 'successConstants'
        state.constants = constants
    },
    successRequestDetails(state, request_details) {
        state.status = 'successRequestDetails'
        state.psp = request_details.psp
        let documents = request_details.documents
        let images_url = {
            card_acceptance_contract:[],
            statute_pages_img:[],
        }
        for (var key in documents) {
            images_url[key] = documents[key].url
        }
        state.request_details = request_details
        state.request_details.images_url = images_url
    },
    successDocuments(state, documents) {
        state.status = 'successDocuments'
        state.documents = documents
    },
    setFormData(state, stakeholder) {
        state.status = 'setFormData'
        state.form_data.stakeholders.push(stakeholder)
    },
    canChange(state, permit) {
        state.status = 'canChange'
        state.can_change = permit
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        state.form_data = false
        state.form_data = {
            customer_detail: {},
            bank_account_detail: {
                multi_account_details: [],
                multi_account_owners: [],
            },
            stakeholders: [],
            sub_customers: [],
            device_info: {},
            address_info: {},
            images_url: {
                national_card_img: '',
                birth_certificate_card_img: '',
                national_card_behind_img: '',
                last_newspaper_img: '',
                statute_pages_img: '',
                foundation_img: '',
                passport_img: '',
                amayesh_card_img: '',
                work_permit_img: '',
                certificate_img: '',
                business_license_img: '',
                first_ownership_document_img: '',
                second_ownership_document_img: '',
                communicating_documents_img: '',
                license_granting_certificate_img: '',
                trust_number_img: '',
                iban_certificate: '',
                change_iban_form: '',
                installation_form: '',
                deposit_receipt: '',
                phone_bill: '',
                e_trust_certificate: '',
                card_acceptance_contract: '',
                national_card_of_second_sh: '',
                renting_or_ownership_document: '',
                delegation_of_authority_form: '',
                last_newspaper_img_introduce_sh: '',
                delegation_of_authority_national_card: '',
                birth_certificate_first_page_of_first_sh: '',
                birth_certificate_first_page_of_second_sh: '',
                certificate_form: '',
            },
            documents: {
                national_card_img: '',
                birth_certificate_card_img: '',
                national_card_behind_img: '',
                last_newspaper_img: '',
                statute_pages_img: '',
                foundation_img: '',
                passport_img: '',
                amayesh_card_img: '',
                work_permit_img: '',
                certificate_img: '',
                business_license_img: '',
                first_ownership_document_img: '',
                second_ownership_document_img: '',
                communicating_documents_img: '',
                license_granting_certificate_img: '',
                trust_number_img: '',
                iban_certificate: '',
                change_iban_form: '',
                installation_form: '',
                deposit_receipt: '',
                phone_bill: '',
                e_trust_certificate: '',
                card_acceptance_contract: '',
                national_card_of_second_sh: '',
                renting_or_ownership_document: '',
                delegation_of_authority_form: '',
                last_newspaper_img_introduce_sh: '',
                delegation_of_authority_national_card: '',
                birth_certificate_first_page_of_first_sh: '',
                birth_certificate_first_page_of_second_sh: '',
                certificate_form: '',
            },
        }
    },
    addMultiAccount(state, data) {
        data.index = state.form_data.bank_account_detail.multi_account_details.length + 1
        state.form_data.stakeholders.push(data.stakeholder_hashid)
        state.form_data.bank_account_detail.multi_account_details.push(data)
    },
    addMultiAccountOwner(state, data) {
        data.index = state.form_data.bank_account_detail.multi_account_owners.length + 1
        state.form_data.bank_account_detail.sub_customers.push(data)
    },
    editMultiAccount(state, data) {
        state.form_data.bank_account_detail.multi_account_details[data.index - 1] = data
    },
    removeMultiAccount(state, index) {
        if (index > -1) {
            state.form_data.bank_account_detail.multi_account_details.splice(index, 1);
            state.form_data.stakeholders.splice(index, 1);
        }
    },
    setDatatableStatus(state, status) {
        state.datatable_status = status
    },
    clearRequestDetails(state) {
        state.request_details = null
    },
}

const getters = {
    status: ({status}) => status,
    psp: ({psp}) => psp,
    datatable_status: ({datatable_status}) => datatable_status,
    can_change: ({can_change}) => can_change,
    constants: ({constants}) => constants,
    settings_status: ({settings_status}) => settings_status,
    form_data: ({form_data}) => form_data,
    documents: ({documents}) => documents,
    request_details: ({request_details}) => request_details,
    multi_account_details: (state) => {
        state.form_data.bank_account_detail.multi_account_details
    },
}

const actions = {
    fetch({commit}) {
        commit('clearConstants')
        return posService.fetch().then(response => {
            commit('successConstants', response.data.data[0])
        })
    },

    addPosRequest({commit}, form_data) {
        commit('loading')
        return posService.addPosRequest(form_data).then(response => {
            // commit('successPosRequest', response.data.data)
        })
    },
    removeMultiAccount({commit}, data) {
        commit('loading')
        return posService.removeStakeholder(data.stakeholder_id).then(response => {
            commit('removeMultiAccount', data.index)
        })
    },
    getRequestDetails({commit}, hashid) {
        commit('clearRequestDetails')
        return posService.getPosRequestDetails(hashid).then(response => {
            commit('successRequestDetails', response.data.data)
        })
    },
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}